module.exports = __webpack_public_path__ + "static/media/schuettler_mit.7838f004.jpg";